import { defaultAdminIntegrationName } from "../httpService";
import { getIntegrationName } from "./stateGetter";
export var isAdminIntegration = function (state) {
    return getIntegrationName(state) === defaultAdminIntegrationName;
};
